// removed by extract-text-webpack-plugin
module.exports = {"list-userinfo":"list-userinfo","news-tab-content":"news-tab-content","userinfo-header":"userinfo-header","userinfo-table":"userinfo-table","userinfo-item":"userinfo-item","new-userinfo-item":"new-userinfo-item","userinfo-table-header":"userinfo-table-header","userinfo-table-list":"userinfo-table-list","btn-see-more-wrap":"btn-see-more-wrap"};


//////////////////
// WEBPACK FOOTER
// ./components/partials/userinfo/_userinfo.scss
// module id = ./components/partials/userinfo/_userinfo.scss
// module chunks = 0